/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { WidgetDropHandlerEditing } from './widget-drop-handler-editing';

export class WidgetDropHandler extends Plugin {
  static get pluginName() {
    return 'WidgetDropHandler';
  }

  static get requires() {
    return [WidgetDropHandlerEditing];
  }
}
